<template>
  <notes
    description="General Notes related to this Adventure"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    tour: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "tour"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.tour.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
